// extracted by mini-css-extract-plugin
module.exports = {"subscription":"SubscriptionItem_subscription__zBZh4","itemsArea":"SubscriptionItem_itemsArea__1b0r8"};